import { PlanningEntityMap } from 'components/roster-portal/activity-planning/types';
import {
  EventResponse,
  PlanningTaskCategoryResponse,
  PlanningTaskTypeResponse,
  ScheduleResponse
} from 'generated/index';

export enum TaskListCategory {
  TO_PLAN_APPOINTMENTS = 'TO_PLAN_APPOINTMENTS',
  SCHEDULE_TO_ASSIGN = 'SCHEDULE_TO_ASSIGN'
  // URGENT = 'URGENT',
  // WARNINGS = 'WARNINGS'
}

export interface TaskListProps {
  onOpen?: () => void;
  onClose?: () => void;
  planningEntities: PlanningEntityMap | null;
  dropzonePadding?: string;
  activeEntityContainingSelection: string | null;
  onChangeActiveEntity: (entityId: string) => void;
  onChangeSelection: (selectionIds: string[]) => void;
  onChangeMousePosition?: (pos: { x: number; y: number }) => void;
  onRouteClick?: (date: Date, routeId?: string) => void;
  isTimeline?: boolean;
}

export interface ScheduleTask {
  type?: PlanningTaskTypeResponse;
  category?: PlanningTaskCategoryResponse;
  data?: ScheduleResponse;
}

export type ScheduleTaskData = ScheduleResponse;
export type PlanningTaskData = EventResponse;

export interface PlanningTask {
  category: string;
  data?: PlanningTaskData;
}

export interface RouteEntity {
  planningTasks: ScheduleTask[];
}
export interface Dropzone {
  id: string;
  category: 'DROPZONE';
  droppable: boolean;
  start: string;
}
